import React, { useState, useEffect } from "react";
import { useSubheader } from "../../../../_metronic/layout";
import {
    Card,
    CardBody,
    CardHeader,
} from "../../../../_metronic/_partials/controls";
import { useHistory } from "react-router-dom";
import axios from "axios";
import { baseURL, baseURLV1, imageURL } from "../../../service/API.js";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";
import CropperImage from "../CropperImage";
import { useIntl } from "react-intl";
import { temp_store } from "../../../modules/function/temp_store"
import { useSelector } from "react-redux";



export const CreateDetail = (props) => {
    const intl = useIntl();
    const suhbeader = useSubheader();
    const history = useHistory();
    const [key, setKey] = useState("")
    const [datatemp, setData] = useState([])
    const [textbox, setTextbox] = useState([])
    const { user } = useSelector((state) => state.auth);
    const [grouplist, setGrouplist] = useState([])
    const [group, setGroup] = useState([])
    const [value, setValue] = useState()
    const [displayOrder, setDisplayOrder] = useState(0)


    useEffect(() => {
        setMapData(props.location.state.key)
        setTextbox(props.location.state.key)
        console.log(props.location.state)
        getList()
    }, []);



    const setMapData = (data) => {

        let temp = []
        data.map(item => {
            temp.push({
                key_id: item.id,
                item_id: props.location.state.data.id,
                value: ''
            })

        })
        setData(temp)
        console.log(datatemp)
    }

    const setMapEditData = (index, value) => {
        let temp = [...datatemp]
        temp[index] = {
            item_id: temp[index].item_id,
            key_id: temp[index].key_id,
            value: value
        }
        setData(temp)
        console.log(datatemp)
    }

    suhbeader.setTitle(`Create Detail ${key}`);
    const [stateItem_image_path, setStateItem_image_path] = useState({
        previewItem_image_path: null,
        rawItem_image_path: null,
        imageURLItem_image_path: null,
    });

    const AlertError = (message) => {
        Swal.fire("Alert", message, "error");
    };


    const updateFieldChanged = (index, e) => {
        console.log(textbox)
        console.log('index: ' + index);
        console.log('property name: ' + e.target.value);
        let newArr = [...textbox]; // copying the old datas array
        textbox[index].deletedAt = e.target.value; // replace e.target.value with whatever you want to change it to
        setTextbox(newArr);
        setMapEditData(index, e.target.value)
    }

    const onSubmit = async () => {
        
        

        const data = key.split(',')
        console.log(data)

        if (value === undefined || value === "") {
            return AlertError("Please insert value !!");
        }

        if (data[0] === undefined || data[0] === "") {
            return AlertError("Please insert key !!");
        }

        if (data[1] === undefined || data[1] === "") {
            return AlertError("Please insert value !!");
        }
        let apiUrls = `${baseURLV1}/itemDetail`;
        //let token = localStorage.getItem("Token");
        console.log(datatemp)
        axios({
            method: "post",
            url: apiUrls,
            headers: {
                Accept: "application/json",
                Authorization: `Bearer ${user.data.access_token}`,
            },
            data: {
                item_id: String(props.location.state.data.id),
                key_id: String(data[0]),
                value: value,
                ordering: data[1]
            }
        }).then(async (res) => {
            history.goBack();
        })
            .catch((err) => {
                Swal.fire(
                    "Create !",
                    "Your can not Create Detail. !! " + err,
                    "error"
                );
            });
    };

    const getList = async () => {
        const apiUrls = `${baseURLV1}/itemKey/${props.location.state.data.id}?page=1&limit=10000`;
        //let token = localStorage.getItem("token");

        await axios({
            method: "get",
            url: apiUrls,
            headers: {
                Accept: "application/json",
                Authorization: `Bearer ${user.data.access_token}`,
            },
        })
            .then((res) => {

                console.log(res.data)

                setGrouplist(res.data)
            })
            .catch((err) => {
                if (err.response) {

                }
            });
    };



    return (
        <>
            <Card>
                <CardHeader title={"Create Detail"}></CardHeader>
                <CardBody>
                <div className="form-inline" style={{ marginBottom: "25px" }}>
                        <p style={{ marginTop: "15px", float: "left", width: "20%" }}>
                            <span style={{ color: "red" }}>
                                *
                            </span>
                            {intl.formatMessage({ id: "###", defaultMessage: "Key Name" })}:{" "}
                        </p>
                        <select
                            as="select"
                            style={{
                                height: "38px",
                                width: "530px",
                                backgroundColor: "#F4F6F9",
                                borderRadius: "5px",
                                borderWidth: "0",
                            }}
                            value={key}
                            onChange={e => setKey(e.target.value)}
                        >
                            <option value="">{intl.formatMessage({ id: "###", defaultMessage: "Please select" })}</option>
                            {grouplist &&
                                grouplist.map((result, index) => {
                                    return (
                                        <option key={index} value={`${result.id},${result.ordering}`}>
                                            {result.key}
                                        </option>
                                    );
                                })}
                        </select>
                    </div>
                    <div className="form-inline" style={{ marginBottom: "25px" }}>
                        <p style={{ marginTop: "15px", float: "left", width: "20%" }}>
                            <span style={{ color: "red" }}>
                                *
                            </span>
                            {intl.formatMessage({ id: "###", defaultMessage: "Value" })}:{" "}
                        </p>
                        <input
                            name="modelGroup"
                            style={{
                                height: "38px",
                                width: "530px",
                                backgroundColor: "#F4F6F9",
                                borderRadius: "5px",
                                borderWidth: "0",
                            }}
                            value={value}
                            onChange={(e) => setValue(e.target.value)}
                        />
                    </div>
                    <div
                        className="form-inline"
                        style={{
                            marginBottom: "25px",
                        }}
                    >
                        <div
                            style={{
                                marginTop: "15px",
                                float: "left",
                                width: "20%",
                            }}
                        ></div>
                        <Link to="/EditItemDetail">
                            <button type="button" className="btn btn-secondary wbt mr-5">
                                {intl.formatMessage({ id: "104047", defaultMessage: "Cancel" })}
                            </button>
                        </Link>
                        <button className="btn btn-primary" onClick={() => onSubmit()}>
                            {intl.formatMessage({ id: "104048", defaultMessage: "Save" })}
                        </button>
                    </div>
                </CardBody>
            </Card>
        </>
    );
};
